import axiosInstance from "./axiosInstance";

export default {
  async getCountries() {
    const res = await axiosInstance.get(`/api/countries/all`);
    return res;
  },
  async getCities(filter) {
    const res = await axiosInstance.get(`/api/cities/all`, {
      params: {
        queryComplex: filter,
      },
    });
    return res;
  },
};
